import React, { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const DpdPinIcon = ({ className, color }) => (
  <SvgIcon
    viewBox="0 0 26 26"
    className={className}
    fill="none"
    width="26"
    height="26"
  >
    <g clipPath="url(#clip0_3_1254)">
      <rect width="26" height="26" rx="4" fill={color} />
      <g clipPath="url(#clip1_3_1254)">
        <path
          d="M19.666 10.1471L16.1219 12.3355C16.0824 12.3592 16.0318 12.3714 15.9798 12.3714C15.9226 12.3714 15.868 12.3565 15.8272 12.3301L15.7173 12.2596L15.3568 12.0292C15.2765 11.9784 15.214 11.8626 15.214 11.7657V11.3836V11.1925C15.214 11.0949 15.2785 10.9574 15.3607 10.9086L15.4331 10.8639L19.0568 8.62607L13.6759 5.5542C13.5502 5.48239 13.3443 5.48171 13.2186 5.55353L7.66929 8.65656L14.1042 12.4493C14.1877 12.4961 14.2509 12.6078 14.2509 12.7088V12.7339V13.0963L14.2502 13.9358L14.2482 18.1804C14.2482 18.2793 14.1824 18.3932 14.0982 18.4392L13.6134 18.7157C13.6134 18.7157 13.6081 18.7163 13.6061 18.7177C13.5667 18.7373 13.5193 18.7502 13.4686 18.7502H13.4594C13.4015 18.7516 13.3469 18.7401 13.3048 18.7163L12.9989 18.5422L12.818 18.4392C12.7351 18.3938 12.6699 18.2793 12.6699 18.1804L12.6686 13.9358H12.6673V13.5726C12.6627 13.5211 12.6265 13.4581 12.5864 13.4351L7.16929 10.2081L7.16666 16.5164C7.16666 16.6641 7.26797 16.8471 7.39231 16.9216L13.2305 20.444C13.3548 20.5192 13.5574 20.5185 13.6811 20.4427L19.4423 16.9169C19.566 16.841 19.6667 16.658 19.6667 16.5103L19.666 10.1471Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3_1254">
        <rect width="26" height="26" fill="white" />
      </clipPath>
      <clipPath id="clip1_3_1254">
        <rect width="20" height="20" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default memo(DpdPinIcon);
